import React from 'react';
import { ShieldCheck } from 'lucide-react';

const SECTION_LABELS = {
  probound: 'ProBound',
  proepoxy: 'ProEpoxy',
  prodecor: 'ProDecor',
  resin_bound_stone: 'Resin Bound Stone',
  rubber_crumb: 'Rubber Crumb',
  savoro_flooring: 'Savoro Flooring'
};

// Sub-categories that belong to ProBound
const PROBOUND_CATEGORIES = ['resin_bound_stone', 'rubber_crumb', 'savoro_flooring'];

const ApprovedBadge = ({ user, section, compact = false }) => {
  if (!user?.approved_installer) return null;
  
  // If section is probound, check if approved in any probound sub-category
  if (section === 'probound') {
    const hasAnyProbound = PROBOUND_CATEGORIES.some(cat => user.approved_installer[cat]);
    if (!hasAnyProbound && !user.approved_installer.probound) return null;
    
    if (compact) {
      return (
        <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-green-100 text-green-700 rounded-full text-[10px] font-medium" title="Approved Installer">
          <ShieldCheck className="w-3 h-3" />
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-700 rounded-full text-xs font-medium">
        <ShieldCheck className="w-3 h-3" />
        Approved
      </span>
    );
  }
  
  // If specific sub-category
  if (section && !user.approved_installer[section]) return null;
  if (section) {
    if (compact) {
      return (
        <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-green-100 text-green-700 rounded-full text-[10px] font-medium" title={`Approved: ${SECTION_LABELS[section]}`}>
          <ShieldCheck className="w-3 h-3" />
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-700 rounded-full text-xs font-medium">
        <ShieldCheck className="w-3 h-3" />
        Approved
      </span>
    );
  }
  
  // No section specified — show if approved in anything
  const approvedSections = Object.entries(user.approved_installer)
    .filter(([_, approved]) => approved)
    .map(([sec]) => sec);
  
  if (approvedSections.length === 0) return null;
  
  if (compact) {
    return (
      <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-green-100 text-green-700 rounded-full text-[10px] font-medium" title={`Approved: ${approvedSections.map(s => SECTION_LABELS[s] || s).join(', ')}`}>
        <ShieldCheck className="w-3 h-3" />
      </span>
    );
  }
  
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-700 rounded-full text-xs font-medium">
      <ShieldCheck className="w-3 h-3" />
      Approved
    </span>
  );
};

export default ApprovedBadge;
